import type { JsonPatchOperation } from '@/shared/types/common';
import type { UpdateOwnerItem } from '@/shared/types/owner';

import type { TeamOwner, UserOwner } from '@/entities/owner/domain/types';

type BuildNewOwnersParams = {
  selectedTeamId: string | null;
  selectedUserIds: string[];
  teams: TeamOwner[];
  users: UserOwner[];
};

export const buildNewOwners = ({
  selectedTeamId,
  selectedUserIds,
  teams,
  users,
}: BuildNewOwnersParams): UpdateOwnerItem[] => {
  const newOwners: UpdateOwnerItem[] = [];

  if (selectedTeamId) {
    const team = teams.find((t) => t.id === selectedTeamId);
    if (team) {
      newOwners.push({
        id: team.id,
        type: 'team',
        name: team.name,
        fullyQualifiedName: team.fullyQualifiedName,
        displayName: team.displayName,
      });
    }
  }

  selectedUserIds.forEach((userId) => {
    const user = users.find((u) => u.id === userId);
    if (user) {
      newOwners.push({
        id: user.id,
        type: 'user',
        name: user.name,
        fullyQualifiedName: user.fullyQualifiedName,
        displayName: user.displayName,
      });
    }
  });

  return newOwners;
};

type BuildOwnerOperationsParams = {
  newOwners: UpdateOwnerItem[];
  currentOwners: UpdateOwnerItem[];
};

export const buildOwnerOperations = ({
  newOwners,
  currentOwners,
}: BuildOwnerOperationsParams): JsonPatchOperation[] => {
  const operations: JsonPatchOperation[] = [];

  if (currentOwners && currentOwners.length > 0) {
    operations.push({
      op: 'replace',
      path: '/owners',
      value: newOwners,
    });
  } else {
    operations.push({
      op: 'add',
      path: '/owners',
      value: newOwners,
    });
  }

  return operations;
};
